module.exports = __webpack_public_path__ + "img/cooperation_unit_05.ad6fafd4.png";